/**
 * Image Workflows Page
 * Visual workflow editor for chaining image operations
 */

import { useState, useCallback } from 'react';
import { WorkflowList, WorkflowEditor } from '@/features/image-workflows';
import type { Workflow } from '@/types/imageWorkflow';

type ViewMode = 'list' | 'editor';

export function ImageWorkflowsPage() {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string | null>(null);

  // Handle workflow selection
  const handleSelectWorkflow = useCallback((workflow: Workflow) => {
    setSelectedWorkflowId(workflow.id);
    setViewMode('editor');
  }, []);

  // Handle new workflow
  const handleNewWorkflow = useCallback(() => {
    setSelectedWorkflowId(null);
    setViewMode('editor');
  }, []);

  // Handle back to list
  const handleBack = useCallback(() => {
    setViewMode('list');
    setSelectedWorkflowId(null);
  }, []);

  // Handle save (refresh list if needed)
  const handleSave = useCallback((workflow: Workflow) => {
    setSelectedWorkflowId(workflow.id);
  }, []);

  return (
    <div className="h-[calc(100vh-4rem)]">
      {viewMode === 'list' ? (
        <div className="h-full overflow-y-auto p-6 bg-gray-50">
          <WorkflowList
            onSelect={handleSelectWorkflow}
            onNew={handleNewWorkflow}
          />
        </div>
      ) : (
        <WorkflowEditor
          workflowId={selectedWorkflowId}
          onBack={handleBack}
          onSave={handleSave}
        />
      )}
    </div>
  );
}
